import React, { useMemo } from "react"
import ShortReservationPopup from "../../components/ShortReservationPopup"
import { PopupTypes } from "./icons"
import PropTypes from 'prop-types'
export const HomePagePopups = ({active, HotelId, ...rest})=>{
    const newReservation = useMemo(()=>({
        HotelId,
        ReservationPricingTypeId: 1,
        TotalAmountProductCurrentBeforeTax: 0,
        TotalAmountProductCurrentAfterTax: 0
    }), [HotelId])
    return <>
        <ShortReservationPopup open={active === PopupTypes.ShortReservation} reservation={newReservation} { ...rest}/>
    </>
}


HomePagePopups.propTypes = {
    active: PropTypes.number,
    HotelId: PropTypes.number
}